var viewer_caption_rtlignore_default = {
  "fontElementMap": "w--ty",
  "imageCaption": "qc164"
};
export {
  viewer_caption_rtlignore_default as default
};
//# sourceMappingURL=viewer-caption.rtlignore-scss.js.map
